import { render } from "./ItemUpdate.vue?vue&type=template&id=0af9d65b"
import script from "./ItemUpdate.vue?vue&type=script&lang=js"
export * from "./ItemUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__